/** When your routing table is too long, you can split it into small modules**/

export default [
  {
    path: "/jazb",
    name: "Jazb",
    component: () => import("@/views/jazb/Index"),
  },
  {
    path: "/jazb-history",
    name: "JazbHistory",
    component: () => import("@/views/jazb/History"),
  },
  {
    path: "/ezam",
    name: "Ezam",
    component: () => import("@/views/ezam/Index"),
  },
  {
    path: "/ezam-history",
    name: "EzamHistory",
    component: () => import("@/views/ezam/Ezam"),
  },
  {
    path: "/ezamrequest",
    name: "EzamRequest",
    component: () => import("@/views/ezamrequest/Index"),
  },
  {
    path: "/ezamrequest-history",
    name: "EzamRequestHistory",
    component: () => import("@/views/ezamrequest/History"),
  },
];

